import { inuseAppAPI } from '../api/ApprsAPI'

export function useApprs() {

  const onInUseApp = async (app_id: number) => {
    try {
      const result = await inuseAppAPI(app_id)
      return result
    } catch (e) {
      console.error("inuseAppAPI 중 에러 발생:", e)
    }
  }
  return {
    onInUseApp
  }
}